import React, { ButtonHTMLAttributes, FC } from 'react'
import styled from 'styled-components'

import CloseIcon from '@Assets/SVG/Close'
import { SVGIcon } from '@Components/Icons'

const ResetButton = styled.button`
  border: none;
  background-color: transparent;
  padding: 17px;
  > svg {
    fill: ${({ theme }) => theme.colors.grey};
  }
`

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const ResetAdornment: FC<ButtonProps> = props => (
  <ResetButton
    {...props}
    type="button"
  >
    <SVGIcon icon={CloseIcon} size="100%" />
  </ResetButton>
)
